import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/classes';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageClasses() {
  return (
    <Root title={PAGE_TITLE.CLASSES}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
